var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NewContainer',{attrs:{"cv-id":_vm.$route.params.cv_id,"section":_vm.cvSectionDate}})}
var staticRenderFns = []

export { render, staticRenderFns }